import { RootState } from '../index';

export const getTimedoctorConfig = (state: RootState) => state.timedoctor.config;

export const getTimedoctorLoading = (state: RootState) => state.timedoctor.loading;

export const getTimedoctorError = (state: RootState) => state.timedoctor.error;

export const getTimeDoctorUsers = (state: RootState) => state.timedoctor.users;
